
import React from "react";
import {
  getBezierPath,
} from "react-flow-renderer";

import "./css/buttonedge.css";

export default function RemoveEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  sourceHandleId,
  style = {},
  data
}) {
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });
  const markerId = `arrow-${id}`;
  const gradId = `grad-${id}`;

  const edgeColor = "var(--flow-edge-color)";
  const markerColor = "var(--flow-handle-color)";

  return (
    <>
      <defs>
        <linearGradient id={gradId} gradientUnits="userSpaceOnUse" x1={sourceX} y1={sourceY} x2={targetX} y2={targetY}>
          <stop offset="0%" stopColor={edgeColor} />
          <stop offset="100%" stopColor={edgeColor} />
        </linearGradient>
        <marker
          id={markerId}
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="6"
          markerHeight="6"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill={markerColor} />
        </marker>
      </defs>
      <path
        id={id}
        style={{ ...style, stroke: `url(#${gradId})`, filter: "none" }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={`url(#${markerId})`}
      />
      <path
        d={edgePath}
        fill="none"
        stroke="rgba(0,0,0,0.01)"
        strokeWidth={44}
        className="react-flow__edge-interaction flow-edge-hitbox"
        style={{ pointerEvents: "stroke", cursor: "context-menu" }}
        onContextMenu={(event) => data?.onContextMenu?.(event, id)}
      />
    </>
  );
}

